module.exports = {
    placeholder: {
        search: "search"
    },
    about: 'About US',
    projects: 'DeFi Project List',
    website: 'DeFi Navigtion'
}